import React, { useState, useEffect, useCallback } from "react";
import { Loader, Pagination, Button } from "semantic-ui-react";
import { UsersDB } from "../../../../api";
import { UsersDBItem } from "../UsersDBItem";
import { UserDetailsModal } from "../UserDetailsModal";
import { useAuth } from "../../../../hooks";
import "./ListUsersDB.scss";

export function ListUsersDB() {
  const [users, setUsers] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(0);
  const [modalOpen, setModalOpen] = useState(false);
  const [selectedUser, setSelectedUser] = useState(null);
  const [idClient, setIdClient] = useState(null);
  const [idClientPadre, setIdClientPadre] = useState(null);
  const { user } = useAuth();
  const usersPerPage = 10; // Limite de usuarios por página

  // Función asíncrona para recargar usuarios
  const reloadUsers = useCallback(async () => {
    if (!idClient) return;

    try {
      const usersDb = new UsersDB();
      const data = await usersDb.getListsimpleData(idClient);

      // console.log("Datos recibidos de la API:", data); // Revisar los datos

      // Verificar si data es un array directamente o si tiene la propiedad `users`
      const usersList = Array.isArray(data) ? data : data.users;

      // Verificar que cada usuario tiene `_id`
      usersList.forEach((user) => {
        if (!user._id) {
          console.error("Usuario sin _id detectado:", user);
        }
      });

      setUsers(usersList); // Asignar usuarios
      setIdClientPadre(data._id || idClient); // Obtener el _id del cliente padre
      setTotalPages(Math.ceil(usersList.length / usersPerPage)); // Calcular el total de páginas
    } catch (error) {
      console.error("Error al cargar los usuarios:", error);
    }
  }, [idClient, usersPerPage]);

  useEffect(() => {
    const hash = window.location.hash;
    const queryParams = new URLSearchParams(hash.split("?")[1]);
    const idFromUrl = queryParams.get("id");

    if (idFromUrl) {
      setIdClient(idFromUrl);
      // console.log("ID capturado de la URL:", idFromUrl);
    } else {
      // console.log("NameClient:", user);
    }
  }, [user]);

  useEffect(() => {
    reloadUsers(); // Cargar los usuarios cuando se cambie la página
  }, [currentPage, idClient, reloadUsers]); // Agregar reloadUsers como dependencia

  const handleViewDetails = (user) => {
    setSelectedUser(user);
    setModalOpen(true);
  };

  const handleCloseModal = () => {
    setModalOpen(false);
    setSelectedUser(null);
  };

  const handlePageChange = (e, { activePage }) => {
    setCurrentPage(activePage);
  };
  // Nueva función para exportar los datos a un archivo .txt con encabezado
  const exportToTxt = async () => {
    const usersDb = new UsersDB();
    const allUsersData = await usersDb.getAllUsersByClient(idClient);

    // Calcular el total de alumnos y niveles completados
    const totalAlumnos = users.length;
    let totalLevelsCompletados = 0;

    // Recorrer todos los usuarios para sumar sus niveles completados
    allUsersData.users.forEach((user) => {
      user.data.forEach((detail) => {
        if (detail.progress === "100%" || detail.progress === "100") {
          totalLevelsCompletados++;
        }
      });
    });

    // Crear el encabezado con el total de alumnos y niveles completados
    const header = `Total de Alumnos: ${totalAlumnos}\nTotal de Levels Completados: ${totalLevelsCompletados}\n\n`;

    // Formatear los datos de cada usuario, incluyendo detalles en una tabla
    const userData = users
      .map((user) => {
        const userDetails =
          allUsersData.users.find((u) => u.name === user.name)?.data || [];

        // Información básica del usuario
        let userText = `Nombre: ${user.name}\nSiglas: ${user.marca}\nRama: ${user.rama}\nUbicacion: ${user.ubication}\nLevels: ${user.levels}\nCompletados: ${user.completados}\n`;

        // Agrega una tabla de detalles del usuario
        userText += "Detalles:\nNivel\tTarea\tProgreso\tTiempo\tCompletado\n";
        userDetails.forEach((detail) => {
          userText += `${detail.level}\t${detail.tarea}\t${detail.progress}\t${
            detail.time
          }\t${
            detail.progress === "100%" || detail.progress === "100"
              ? "Sí"
              : "No"
          }\n`;
        });
        userText += "\n"; // Agrega un salto de línea entre usuarios

        return userText;
      })
      .join("\n");

    // Combina el encabezado y los datos de los usuarios
    const fileContent = header + userData;

    // Crea un blob de tipo texto para preparar el archivo de descarga
    const blob = new Blob([fileContent], { type: "text/plain" });

    // Crea un enlace temporal para descargar el archivo
    const link = document.createElement("a");
    link.href = URL.createObjectURL(blob); // Asigna el blob como fuente de enlace
    link.download = "usuarios.txt"; // Nombre del archivo a descargar
    link.click(); // Simula el clic en el enlace para iniciar la descarga
  };

  if (!idClient) {
    return (
      <div className="list-users-db">
        <h2>No existen usuarios para este cliente</h2>
      </div>
    );
  }

  if (!users.length || !idClientPadre)
    return <Loader active inline="centered" />;

  const startIndex = (currentPage - 1) * usersPerPage;
  const paginatedUsers = users.slice(startIndex, startIndex + usersPerPage);

  //console.log("Usuarios paginados:", paginatedUsers);

  return (
    <div className="list-users-db">
      <table>
        <thead>
          <tr>
            <th>Nombre</th>
            <th>Siglas</th>
            <th>Rama</th>
            <th>Id</th>
            <th>Levels</th>
            <th>Completados</th>
            <th>Ver</th>
          </tr>
        </thead>
        <tbody>
          {idClientPadre ? ( // Solo mapear si idClientPadre está definido
            paginatedUsers.map((user, index) => {
              console.log("Usuario que se pasa a UsersDBItem:", user);

              return user._id ? ( // Solo renderiza UsersDBItem si el usuario tiene un _id
                <UsersDBItem
                  key={user._id} // Usar _id como key en lugar de index para evitar problemas de actualización
                  user={user}
                  onView={handleViewDetails}
                  idClientPadre={idClientPadre} // Pasar idClientPadre
                  reloadUsers={reloadUsers} // Pasar reloadUsers como prop
                />
              ) : (
                <tr key={index}>
                  <td colSpan="4">Error: El usuario no tiene un ID</td>
                </tr>
              );
            })
          ) : (
            <tr>
              <td colSpan="4">Cargando usuarios...</td>
            </tr>
          )}
        </tbody>
      </table>
      <Pagination
        activePage={currentPage}
        totalPages={totalPages}
        onPageChange={handlePageChange}
      />
      {selectedUser && (
        <UserDetailsModal
          open={modalOpen}
          onClose={handleCloseModal}
          user={selectedUser}
          id_Client={idClient}
        />
      )}
      <div className="exportBtn">
        <Button primary onClick={exportToTxt}>
          Exportar a TXT
        </Button>
      </div>
    </div>
  );
}
